var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobeOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.99935C18.3333 14.6017 14.6023 18.3327 9.99996 18.3327M18.3333 9.99935C18.3333 5.39698 14.6023 1.66602 9.99996 1.66602M18.3333 9.99935H1.66663M9.99996 18.3327C5.39759 18.3327 1.66663 14.6017 1.66663 9.99935M9.99996 18.3327C12.0844 16.0507 13.2689 13.0893 13.3333 9.99935C13.2689 6.90938 12.0844 3.94798 9.99996 1.66602M9.99996 18.3327C7.91556 16.0507 6.731 13.0893 6.66663 9.99935C6.731 6.90938 7.91556 3.94798 9.99996 1.66602M1.66663 9.99935C1.66663 5.39698 5.39759 1.66602 9.99996 1.66602",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobeOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/globe-outline.c604e51522169890ed32fc41f5614d0b.svg";